import { useState } from 'react';
import { SearchSuggestion } from './SearchSuggestion';

type UseMultiValueSearchValue = {
  value: string;
  setValue: (newValue: string) => void;
  options: SearchSuggestion[];
};

const useMultiValueSearch = (
  allOptions: SearchSuggestion[],
  selectedItems: SearchSuggestion[],
  preventDuplicateSelection = false,
): UseMultiValueSearchValue => {
  const [value, setValue] = useState('');
  const [options, setOptions] = useState(allOptions);

  return {
    value,
    options,
    setValue: (newValue: string) => {
      setValue(newValue);
      setOptions(
        allOptions
          .filter(
            (opt: SearchSuggestion) =>
              opt.pattern?.test(newValue) &&
              (preventDuplicateSelection ||
                selectedItems.findIndex(({ value: selectedValue }) => selectedValue === opt.value) === -1),
          )
          .map((opt: SearchSuggestion) => {
            return {
              ...opt,
              text: {
                raw: newValue,
                formatted: opt.formatting ? opt.formatting(newValue) : newValue,
              },
            };
          }),
      );
    },
  };
};

export default useMultiValueSearch;
